import { useTranslation } from 'react-i18next';
import { faFileArrowDown } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@shared/components/ui/button';
import { Loader2 } from 'lucide-react';

interface ExportButtonProps {
  onExport: () => void | Promise<void>;
  isExporting: boolean;
  disabled?: boolean;
  className?: string;
}

export const ExportButton = ({ onExport, isExporting, disabled = false, className }: ExportButtonProps) => {
  const { t } = useTranslation('marketingModule');

  return (
    <Button
      onClick={onExport}
      disabled={disabled || isExporting}
      type="button"
      size="sm"
      variant="outline"
      title={t('export.button', 'Exportar XLSX')}
      className={`!py-[9px] !px-2 text-icon bg-body-bg transition-opacity duration-200 ${
        isExporting ? 'opacity-60 pointer-events-none' : ''
      } ${className ?? ''}`}
      data-testid="marketing-export-xlsx"
    >
      {isExporting ? (
        <Loader2 className="h-4 w-4 animate-spin" />
      ) : (
        <FontAwesomeIcon icon={faFileArrowDown} className="h-4 w-4" />
      )}
    </Button>
  );
};
